import React from 'react';
export const YoutubeIframe = ({ videoUrl }) => (<iframe tabIndex={-1} aria-hidden="true" frameBorder={0} allowFullScreen allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" src={videoUrl}></iframe>);
